import CarrierPortalRoute from './routes/carrierPortalRoute';
import { useNavigate } from "react-router-dom";
import { setNavigator } from "./utils/navigate";
import { useEffect } from "react";

const App = () => {
  const navigate = useNavigate();
  useEffect(() => {
    setNavigator(navigate);
  }, [navigate]);
  return (
    <div data-testid="app-component">
      <CarrierPortalRoute />
    </div>

  );
}

export default App;
